import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSElement,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";

const EMPTY_VALUE = "—";

type Props = {
  payPeriodRange: string;
  paidDate?: Date;
  employerName: string;
  paymentMethodLabel: string;
  paymentSplit: number;
  onManagePaymentSettings?: () => void;
};

export const PaystubDetailsCard: React.FC<Props> = ({
  payPeriodRange,
  paidDate,
  employerName,
  paymentMethodLabel,
  paymentSplit,
  onManagePaymentSettings
}) => (
  <WSElement>
    <WSSectionToolbar
      button={{
        label: "Manage payment settings",
        onClick: onManagePaymentSettings
      }}
      title="Paystub details"
    />
    <WSCard mt="M">
      <WSList gap="L">
        <WSDataItem label="Pay period" value={payPeriodRange} />
        <WSDataItem
          label="Paid date"
          value={
            paidDate ? toWSDateString(paidDate, "monthDayYear") : EMPTY_VALUE
          }
        />
        <WSDataItem label="Employer name" value={employerName} />
        <WSDataItem label="Payment method" value={paymentMethodLabel} />
        <WSDataItem label="Payment split" value={`${paymentSplit}%`} />
      </WSList>
    </WSCard>
  </WSElement>
);
